import uuid from "./uuid";
function getFingerprint() {
  let fingerprint = localStorage.getItem("fingerprint");
  if (!fingerprint) {
    fingerprint = uuid();
    localStorage.setItem("fingerprint", fingerprint);
  }
  return fingerprint;
}
var getFingerprint_default = getFingerprint;
export {
  getFingerprint_default as default
};
